import React, { useEffect, useRef, useState,useContext} from 'react';
import './Reservation.css';
import gored from '../assets/gored.jpg'
import kitfo from '../assets/kitfo.jpg'
import tibs from '../assets/tibs.jpg'
import zighinivg from '../assets/zighinivg.jpg'
import zighini from '../assets/zighini.jpg'
import sambusa from '../assets/sambusa.jpg'
import sambusavg from '../assets/sambusavg.jpg'
import categna from '../assets/categna.jpg'
import Sorbetto from '../assets/Sorbetto.jpg'
import dolci1 from '../assets/dolci1.jpg'
import semolino from '../assets/semolino.jpg'
import water from '../assets/water.jpg'
import water2 from '../assets/water2.jpg'
import vino from '../assets/vino.jpg'
import vino2 from '../assets/vino2.jpg'
import softdrinks from '../assets/softdrinks.jpg'
import beer from '../assets/beer.jpg'
import beer2 from '../assets/beer2.jpg'
import limon from '../assets/limon.jpg'
import grappa from '../assets/grappa.png'
import coffee from '../assets/coffee.jpg'
import corretto from '../assets/corretto.jpg'
import tisana from '../assets/tisana.jpg'
import Modals from './Modals';
import {Button, Modal } from 'react-bootstrap';
import Cart from './Cart';
import { BrowserRouter as Router ,Switch,Route,useHistory } from 'react-router-dom';
import {orderContext} from '../Contexts/OrderProvider'
//import { Button,Modal } from 'react-bootstrap';


const Reservation = ()=>{

    const mainDish = [{
        foodName:"Gored Gored",
        price:17,
        description:"Bocconcini di manzo appena saltati aromatizzati,scottati con il nostro burro e berberè",
        image:gored

    },{
        foodName:"Kitfo",
        price:17,
        description:"Carne trita speziata e cotta con il nostro burro (anchenella variante originale crudasemicruda)",
        image:kitfo
    },{
        foodName:"Tibs",
        price:16,
        description:"Carne di manzo a dadini saltata con cipolla, con salsapiccante, mediamente piccante, non piccante",
        image:tibs

    },{
        foodName:"Zighini non veg",
        price:16,
        description:"Spezzatino di manzo, pollo o agnello. Volendo avete lapossibilità di gustare 3 tipi di carne in un unico piattoe di escluderne una a secondo del vostro gradimento.Si aggiunge un unico contorno in vari tipi di salsaspeziata con",
        image:zighinivg
    },{
        foodName:"Zighini vegeterian",
        price:15,
        description:"Con cinque tipi di legumi e verdure (possono esserepresi tutti o anche solo alcuni in base al gustopersonale):",
        image:zighini

    }
]
const starters =[{
foodName:"Sambusa vegeteriano",
price:2,
description:"Fagottino ripieno di verdure                                           ",
image:sambusavg
},{
    foodName:"Sambusa di Carne",
    price:2,
    description:"Fagottino ripieno di carne trita e prezzemolo,leggermente piccante",
    image:sambusa
},
{
    foodName:"Categna",
    price:2,
    description:"Rotolo di injera con burro o olio di oliva chiarificato diberbere",
    image:categna
}
]
const desserts =[{
foodName:"Dolci di cocco",
price:4,
image:dolci1

},{
    foodName:"Dolci di semolino",
    price:4,
    image:semolino

},{
    foodName:"Sorbetto Limone, Mango",
    price:4,
    image:Sorbetto
}]
const drinks =[{
    foodName:"Water 0.5 liter",
    price:1.5,
    image:water
    
    },{
        foodName:"water 1 liter",
        price:3,
        image:water2
    
    },{
        foodName:"vino 0.25 liter",
        price:3,
        image:vino
    },
    {
        foodName:"vino 0.5 liter",
        price:6,
        image:vino2
    
    },{
        foodName:"soft drinks",
        price:2.5,
        image:softdrinks
    },{
        foodName:"Beer 33 cc",
        price:0.75,
        image:beer
    },{
        foodName:"Beer 66 cc",
        price:0.80,
        image:beer2
    },
    {
        foodName:"Limoncelli",
        price:3,
        image:limon
    },{
        foodName:"Grappa ,amara,anice",
        price:3,
        image:grappa
    },
    {
        foodName:"Coffee",
        price:1,
        image:coffee
    },
    {
        foodName:"Caffee corretto",
        price:1.5,
        image:corretto
    },
    {
        foodName:"The Tinsana",
        price:1.5,
        image:tisana
    }
]
const starterList= starters.map((starter)=>
{return(<div className="card-container" onClick={(event)=>{myFunction(event)}}>
        <div class={`card ${starter.foodName}`} >
    <img src={starter.image} class="card-img-top" alt="..."></img>
    <div class={`card-body ${starter.foodName}`}>
      <h5 class="card-title">{starter.foodName}</h5>
      <p class="card-text bg" >{starter.description}</p>
    </div>
    <div class={`item ${starter.foodName}`}>
    <ul class={`list-group list-group-flush ${starter.foodname}`}>
      <li class="list-group-item">Price {starter.price}€ per person</li>
       
    </ul>
    
       </div> 
   
  </div>
  </div>);
  })
 const mainDishes =mainDish.map((dish)=>
 {return(<div className="card-container" onClick={(event)=>{myFunction(event)}}>
      <div class={`card ${dish.foodName}`} >
     <img src={dish.image} class="card-img-top" alt="..."></img>
     <div class={`card-body ${dish.foodName}`}>
       <h5 class="card-title">{dish.foodName}</h5>
       <p class="card-text bg" >{dish.description}</p>
     </div>
     <div class={`item ${dish.foodName}`}>
     <ul class={`list-group list-group-flush ${dish.foodname}`}>
       <li class="list-group-item">Price {dish.price}€ per person</li>
        
     </ul>
     
        </div> 
    
   </div>
   </div>);
   })

   const DessertList =desserts.map((dessert)=>
 {return(<div className="card-container" onClick={(event)=>{myFunction(event)}}>
     <div class={`card ${dessert.foodName}`} >
     <img src={dessert.image} class="card-img-top" alt="..."></img>
     <div class={`card-body ${dessert.foodName}`}>
       <h5 class="card-title">{dessert.foodName}</h5>
       <p class="card-text bg" >{dessert.description}</p>
     </div>
    <div class={`item ${dessert.foodName}`}>
    <ul class={`list-group list-group-flush ${dessert.foodname}`}>
       <li class="list-group-item">Price {dessert.price}€ per person</li>
        
     </ul>
     
        </div> 
    
   </div>
   </div>);
   })
   const drinksList =drinks.map((drink)=>
   {return(<div className="card-container" onClick={(event)=>{myFunction(event)}}>
       <div class={`card ${drink.foodName}`} >
        <div className={drink.foodName}>   
       <img src={drink.image} class="card-img-top" alt="..."></img>
       <div class={`card-body ${drink.foodName}`}>
         <h5 class="card-title">{drink.foodName}</h5>
         <p class="card-text bg" >{drink.description}</p>
       </div>
      <div class={`item ${drink.foodName}`}>
      <ul className={`list-group ${drink.foodName}`}>
         <li class="list-group-item">Price {drink.price}€ per person</li>
          
       </ul>
       
          </div> 
      
     </div>
     </div>
     </div>);
     })
const [openstate,setopenstate]= useState(false);
const [choice,setChoice]=useState({});
const [orders,addOrders] = useContext(orderContext);
useEffect(()=>{
    //
console.log("changed");
},[openstate]);
function myFunction(event) {

 var element=null;   
if(event != undefined){
element=event.target.parentNode;
const menu =[starters,mainDish,drinks,desserts];
menu.forEach((i)=>{

    i.forEach((item)=>{
        console.log("image ",item.image)
        var classname = element.className;
        if(classname.includes(item.foodName)){
             
            setChoice({item:item.foodName,
                        price:item.price,
                        quantity:1,
                        image:item.image, 
                        total:item.price  
                    });
        }
        else 
        console.log("not found");
        
    })
})

}

setopenstate(true);
}
const history = useHistory();
const handleClick = () => history.push('/Cart');
function viewcart(event){
console.log(orders);
}
function findTotal(){
    var sum=0;
    orders.forEach((order)=>{
        sum+=order.quantity;
    })
    console.log(sum);
    return sum;
}
    return(
       
        <div>
            <div className="svg">
            <h3>{findTotal()}</h3>
           <svg xmlns="http://www.w3.org/2000/svg"  fill="currentColor" class="bi bi-cart" viewBox="0 0 16 16" onClick={handleClick}>2
  <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
</svg> 
            </div>
           
            <h1 className="starter">Starters</h1>
    <div className="C" >
    {starterList}
    </div>
    <h1>Main Course</h1>
    <div className="C" >
    {mainDishes}
    </div>
    <h1>Desserts</h1>
    <div className="C">
    {DessertList}
    </div>
    <h1>Drinks</h1>
    <div className="C" >
     {drinksList}
    </div>
    <div className="modals">
         {/* <Button onClick={()=>{setopenstate(true)}}>click me     </Button> */}
     <Modal show={openstate} onHide={myFunction}>   
     <Modal.Header closeButton onClick={(event)=>{setopenstate(false)}}>
         
     </Modal.Header>
     <Modal.Body>
         {choice.item}
     </Modal.Body>
     <Modal.Footer>
         <Button onClick={(event)=>{setopenstate(false)
            var exist =false;
            orders.forEach((order)=>{
                console.log("order ",order.item,"choice ",choice.item);
                if(order.item == choice.item)
                    {  
                        order.quantity=order.quantity+1;
                        order.total=order.quantity*order.price;
                        exist=true;
                        
                    }
            })
            if(!exist && (choice.item != null)){
                console.log("exist ",exist)
                orders.push(choice);
            
            }
            console.log(orders);
        }}> 
            Add to Cart
         </Button>
     </Modal.Footer>
      </Modal>
    
    </div>

        </div>
       
        
        );     
}
export default Reservation;